import type { Manifest, v4 } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { getObjectPageCustomHeaderSectionPath } from '../../application';
import { addPatternForBindingChangeOfEnumOPV4 } from '../../../common';

export class ObjectPageCustomHeaderSectionFlexSettings implements v4.ObjectPageCustomHeaderSectionFlexSettings {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string): string =>
                getObjectPageCustomHeaderSectionPath(pageName, manifest, sectionId, 'flexSettings')
        }
    })
    @validity({
        since: '1.81.0'
    })
    designtime?: v4.DesignTime;
}

export class ObjectPageCustomHeaderSectionFragment implements v4.ObjectPageCustomHeaderSectionFragment {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string): string => {
                return getObjectPageCustomHeaderSectionPath(pageName, manifest, sectionId, 'position');
            },
            key: 'anchor'
        }
    })
    @validity({
        since: '1.77.0'
    })
    relatedFacet: string;

    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string): string =>
                getObjectPageCustomHeaderSectionPath(pageName, manifest, sectionId, 'position'),
            key: 'placement'
        }
    })
    @validity({
        since: '1.77.0'
    })
    relativePosition: v4.SectionPosition;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    visible: boolean;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath
        }
    })
    @validity({
        since: '1.77.0'
    })
    title: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath
        }
    })
    @validity({
        since: '1.77.0'
    })
    subTitle: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath,
            import: (manifestSection: v4.SapUi5RoutingTargetContentSection): string => {
                // During import, we need to consider both `name` and `template` to correctly fill our config and to be upgrade safe
                return manifestSection.name || manifestSection.template;
            },
            key: 'template' // key: 'name' deprecated since '1.86'
        }
    })
    @validity({
        since: '1.77.0'
    })
    fragmentName: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath,
            import: (manifestSection: v4.SapUi5RoutingTargetContentSection): string => {
                return manifestSection.templateEdit;
            },
            key: 'templateEdit' // templateEdit deprecated since '1.86'
        }
    })
    @validity({
        since: '1.86.0'
    })
    templateEdit: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath
        }
    })
    @validity({
        since: '1.81.0'
    })
    stashed: boolean;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath
        }
    })
    @validity({
        since: '1.81.0'
    })
    flexSettings: ObjectPageCustomHeaderSectionFlexSettings;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath
        }
    })
    @validity({
        since: '1.81.0'
    })
    requestGroupId: v4.RequestGroupId;

    @syncRule({
        manifest: {
            path: getObjectPageCustomHeaderSectionPath,
            import: false,
            export: false
        },
        xml: (config: object): string => {
            return config['fragmentName'];
        }
    })
    @validity({
        since: '1.96.0'
    })
    controls: object;
}
